import { useQuery } from '@tanstack/react-query';

import { type ResolveRegionChannelSettingsQuery, resolveRegionChannelSettings } from '~/services/PromoService';

import { regionChannelSettingQueryKeys } from './regionChannelSettingQueryKeys';

type Params = {
  query: ResolveRegionChannelSettingsQuery;
  enabled?: boolean;
};

export function useResolveRegionChannelSettings({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: regionChannelSettingQueryKeys.resolve(query),
    queryFn: async ({ signal }) => resolveRegionChannelSettings(query, { signal }),
    enabled,
    // The endpoint is CDN-cached for 10 minutes, so re-requesting on focus or remount buys nothing
    // and only hides that the answer is a snapshot.
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
